import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-toast',
    imports: [CommonModule],
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.scss'
})
export class ToastComponent implements OnInit{
  showsToast: boolean = true
  @Input() message: string = ''
  @Input() type: ToastType = ToastType.SUCCESS

  constructor() {
  }

  ngOnInit(): void {

  }

  readonly ToastType = ToastType

}

export enum ToastType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
}

